/**
 * Sales Portal — canonical sales teams / commissions UI (flowstate-automate parity).
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { createRouteError } from "../../../components/RouteErrorBoundary";
import { PageSkeleton } from "../../../components/RouteSkeleton";
import SalesPortal from "@/pages/Admin/SalesPortal";
import type { RouterContextWithSession } from "../../../router";

export const Route = createFileRoute("/_admin/sales-portal/")({
  beforeLoad: async ({ context }) => {
    if (typeof window === "undefined") return {};
    const sb = context.supabase;
    if (!sb) return {};
    const {
      data: { session },
    } = await sb.auth.getSession();
    if (!session) {
      throw redirect({ to: "/auth" });
    }
    return { session };
  },
  loader: async ({ context }) => {
    if (typeof window === "undefined") return;
    const { session } = context as RouterContextWithSession;
    if (!session) return;
    await context.queryClient.ensureQueryData({
      queryKey: ["route", "sales-portal"],
      queryFn: async () => null,
      staleTime: Infinity,
    });
  },
  pendingComponent: () => <PageSkeleton rows={6} variant="cards" />,
  errorComponent: createRouteError("Sales Portal"),
  component: SalesPortalRoute,
});

function SalesPortalRoute() {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <SalesPortal />
    </div>
  );
}
